import { TixTime } from '@/TixTime/TixTime';
// This is used for URLs like /events?date=tomorrow
// Probably only OMSI uses this feature.
// See eventListingWithFilters.dateFilters in config.yml
export function dateQueryParamToTixTime(value, timezone) {
    const today = new TixTime(null, timezone);
    const handlers = {
        today: today,
        tomorrow: today.add(1, 'day'),
    };
    if (handlers[value]) {
        return handlers[value];
    }
    else {
        // TODO Support concrete date values. E.g. 2020-06-06
        throw new Error('Unsupported date query string parameter: ' + value);
    }
}
export function formatCartItemDateTime(item, options) {
    const dateTimeFormat = options?.dateTimeFormat ?? 'LONG_DATE_TIME';
    const dateOnlyFormat = options?.dateOnlyFormat ?? 'LONG_DATE';
    const timeOnlyFormat = options?.timeOnlyFormat ?? 'LT';
    const dateTime = (date) => date.format(dateTimeFormat);
    const date = (date) => date.format(dateOnlyFormat);
    const time = (date) => date.format(timeOnlyFormat);
    const mode = item.event.meta.ticket_date_time;
    const { startTime: start, endTime: end } = item;
    if (item.allDay || mode === 'date-only') {
        return date(start);
    }
    else if (mode === 'hidden') {
        return null;
    }
    else if (mode === 'show-end') {
        if (start.isSame(end, 'day')) {
            return `${date(start)} at ${time(start)} to ${time(end)}`;
        }
        else {
            return `${dateTime(start)} to ${dateTime(end)}`;
        }
    }
    else if (mode === 'dates-only-show-end') {
        if (start.isSame(end, 'day')) {
            return date(start);
        }
        else {
            return `${date(start)} to ${date(end)}`;
        }
    }
    else if (mode == null || mode === '') {
        return dateTime(start);
    }
    return mode;
}
